import React from "react";
import prajavani_logo from "../images/prajavani-logo-img.svg";
import union_footer from "../images/union_footer.svg";
import dh_classified_logo from "../images/dh-classifieds.svg";
import classNames from "classnames";
export default function Footer({ footerLable, className = "" }) {
  return (
    <div
      className={classNames(
        "w-full pb-2 pt-4 footer-bg-gradiant border-box",
        className
      )}
    >
      <div className="text-sm items-center text-gray-600 pb-1 font-bold">
        {footerLable}
      </div>
      <div className="w-full mt-2 flex justify-center items-center gap-6">
        <img src={union_footer} alt="union_footer" className="mx-2" />
        <img
          src={prajavani_logo}
          alt="prajavani_logo"
          className="mx-2"
          height={24}
        />
        <img
          src={dh_classified_logo}
          alt="dh_classified_logo"
          className="mx-2"
          height={36}
        />
      </div>
    </div>
  );
}
